<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";
import { onMounted } from 'vue'
import { useRouter } from 'vue-router';

import ArgonButton from "@/components/ArgonButton.vue";

const store = useStore();
// state
const isRTL = computed(() => store.state.isRTL);
const isNavFixed = computed(() => store.state.isNavFixed);

const sidebarColor = () => {
  const sidenav = document.querySelector("#sidenav-main");
  if (sidenav) {
    sidenav.setAttribute("data-color", "warning");
  }
};

// Fija el color del sidebar al montar el componente
onMounted(() => {
  sidebarColor();
});

//const sidebarType = computed(() => store.state.sidebarType);
const toggleConfigurator = () => store.commit("toggleConfigurator");

// mutations
const navbarFixed = () => store.commit("navbarFixed");
const setSidebarType = (type) => store.commit("sidebarType", type);

const darkMode = () => {
  if (store.state.darkMode) {
    store.state.darkMode = false;
    setSidebarType("bg-white");
    deactivateDarkMode();
    return;
  } else {
    store.state.darkMode = true;
    setSidebarType("bg-default");
    activateDarkMode();
  }
};

// We use router to redirect after loging out
const router = useRouter();
// Function to handle session closure
const handleLogout = () => {
  // Delete token from localStorage
  localStorage.removeItem("authToken");
  // Redirect user to login page
  router.push("/signin");
};

</script>
<template>
  <div class="fixed-plugin">
    <div class="shadow-lg card">
      <div class="pt-3 pb-0 bg-transparent card-header">
        <div class="" :class="isRTL ? 'float-end' : 'float-start'">
          <h5 class="mt-3 mb-0">Configuración</h5>
          <p>Preferencias de visualización.</p>
        </div>
        <!-- Start Toggle Button -->
        <div class="mt-4 text-end" @click="toggleConfigurator">
          <button class="p-0 btn btn-link text-dark fixed-plugin-close-button fs-3">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- End Toggle Button -->
      </div>
      <hr class="my-1 horizontal dark" />
      <div class="pt-0 card-body pt-sm-3">
        <!-- Navbar Fixed -->
        <div class="mt-3 d-flex">
          <h6 class="mb-0">Navbar Estilizada</h6>
          <div class="form-check form-switch ps-0 ms-auto my-auto">
            <input class="mt-1 form-check-input" :class="isRTL ? 'float-end  me-auto' : ' ms-auto'" type="checkbox"
              id="navbarFixed" :checked="isNavFixed" @click="navbarFixed" />
          </div>
        </div>
        <!-- Darkmode settings -->
        <hr class="horizontal dark my-4" />
        <div class="mt-2 mb-2 d-flex">
          <h6 class="mb-0" :class="isRTL ? 'ms-2' : ''">Modo Oscuro (Demo)</h6>
          <div class="form-check form-switch ps-0 ms-auto my-auto">
            <input class="form-check-input mt-1 ms-auto" type="checkbox" :checked="store.state.darkMode"
              @click="darkMode" />
          </div>
        </div>
        <!-- Logout button -->
        <hr class="horizontal dark my-4" />
        <div class="mt-2 mb-2 text-center">
          <argon-button @click="handleLogout" color="danger" size="sm" class="ms-auto">
            Cerrar Sesión
          </argon-button>
        </div>

      </div>
    </div>
  </div>
</template>